import React from 'react';
import classnames from 'classnames';

import Skeleton from '@material-ui/lab/Skeleton';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  root: {
    marginRight: theme.spacing(6),
    display: 'flex',
    flexDirection: 'column'
  },
  topSkeleton: { flexGrow: 1 },
  bottomSkeleton: {
    marginTop: theme.spacing(1),
    maxWidth: '50%',
    marginRight: 'auto',
    marginLeft: 'auto'
  },
  border: { borderRadius: theme.shape.borderRadius * 2 }
}));

interface ReviewSkeletonProps {
  height: number
}

function ReviewSkeleton ({ height }: ReviewSkeletonProps) {
  const classes = useStyles();
  return (
    <div className={classes.root} style={{ height }}>
      <Skeleton variant='rect' classes={{ root: classnames(classes.topSkeleton, classes.border) }} />
      <div>
        <Skeleton variant='text' classes={{ root: classnames(classes.bottomSkeleton, classes.border) }} />
      </div>
    </div>
  );
}

export default ReviewSkeleton;
